import type { Microsoft365Source } from '@dbrain/shared';

/** Microsoft's products whose icons Oppy shows: the three sources and Microsoft 365 itself. */
export type MicrosoftProduct = Microsoft365Source | 'm365';

/**
 * Microsoft's own Outlook, OneDrive, SharePoint and Microsoft 365 product icons (Fluent UI Microsoft 365 product
 * icons, build 20251008.001; Microsoft Fabric Assets License, apps/web/public/brand/microsoft/NOTICE.md). Served from
 * Oppy itself (CSP img-src 'self'), shown at their own 16 or 20 px and never changed: no tint, filter, crop or other
 * size (a tile is only a neutral background behind it). Right before the product's full name: a product lineup
 * ("Outlook mail", "OneDrive"), a source's row or label ("SharePoint · Finans", "Outlook ekleri"), the answer cards
 * made of Outlook's facts, where the line beside it starts with "Outlook" (D-201, D-210), and the Bağlantılar card's
 * tile before "Microsoft 365" (D-254). Never as Oppy's logo, never inside a sentence, never for Oppy's own features
 * (those use Oppy's own line icons), and never Microsoft's four-square company logo. The name beside it says what it
 * is, so the image itself is silent.
 */
export function MicrosoftIcon({ product, size = 16 }: { product: MicrosoftProduct; size?: 16 | 20 }) {
  return <img className="ms-icon" src={`/brand/microsoft/${product}_${size}x1.svg`} width={size} height={size} alt="" draggable={false} data-testid={`${product}-icon`} />;
}

/** Outlook's icon: before "Outlook mail" and "Outlook takvim", and on the answer cards' Outlook lines. */
export function OutlookIcon({ size = 16 }: { size?: 16 | 20 }) {
  return <MicrosoftIcon product="outlook" size={size} />;
}
